<template>
  <div class="threshold-detail-container">
    <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >阈值详情</span
      >
      <!-- 详情页面只有导出按钮 -->
      <el-button
        size="small"
        type="success"
        plain
        style="float: right; margin-top: -5px;"
        @click="exportJson"
      >
        导出JSON
      </el-button>
    </div>

    <div class="detail-container" style="margin-top: 30px; padding: 20px;">
      <!-- 基本信息 -->
      <div class="basic-info" style="margin-bottom: 30px;">
        <h3 style="margin-bottom: 15px; color: #303133;">基本信息</h3>
        <el-row :gutter="20">
          <!-- <el-col :span="8">
            <div class="info-item">
              <span class="label">阈值ID：</span>
              <span class="value">{{ threshold.thresholdId }}</span>
            </div>
          </el-col> -->
          <el-col :span="8">
            <div class="info-item">
              <span class="label">阈值名称：</span>
              <span class="value">{{ threshold.name }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">配置数量：</span>
              <span class="value">{{
                threshold.configs ? threshold.configs.length : 0
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="8">
            <div class="info-item">
              <span class="label">创建时间：</span>
              <span class="value">{{ threshold.createDate | parseTime }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">更新时间：</span>
              <span class="value">{{ threshold.updateDate | parseTime }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 阈值配置 -->
      <div class="config-info">
        <h3 style="margin-bottom: 15px; color: #303133;">阈值配置</h3>
        <el-table :data="threshold.configs" border stripe style="width: 100%;">
          <el-table-column
            label="序号"
            type="index"
            width="60"
            align="center"
          />
          <el-table-column
            label="排序"
            prop="configOrder"
            width="80"
            align="center"
          />
          <el-table-column label="阈值Key" prop="configKey" min-width="150" />
          <el-table-column
            label="阈值Value"
            prop="configValue"
            min-width="150"
          />
          <el-table-column
            label="阈值描述"
            prop="configDescription"
            min-width="200"
          >
            <template slot-scope="{ row }">
              <span>{{ row.configDescription || "-" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div
      class="btns"
      style="margin-top: 30px; display: flex; align-items: center; justify-content: center;"
    >
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getThresholdDetail } from "@/store/threshold";

export default {
  name: "ThresholdDetail",
  filters: {
    parseTime(time) {
      if (!time) return "-";
      const date = new Date(time);
      return date.toLocaleString();
    }
  },
  data() {
    return {
      threshold: {
        thresholdId: "",
        name: "",
        configs: [],
        createDate: "",
        updateDate: ""
      },
      loading: false
    };
  },
  created() {
    this.loadThresholdDetail();
  },
  methods: {
    async loadThresholdDetail() {
      const id = this.$route.params.id;
      if (!id) {
        this.$message.error("阈值ID不存在");
        this.$router.go(-1);
        return;
      }

      this.loading = true;
      try {
        const response = await getThresholdDetail(id);
        this.threshold = response;
      } catch (error) {
        console.error("加载阈值详情失败:", error);
        this.$message.error("加载阈值详情失败");
        this.$router.go(-1);
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    exportJson() {
      try {
        // 导出数组格式的原始数据
        const exportData = {
          name: this.threshold.name,
          configs: []
        };

        // 处理configs数组，去掉key中的"config"前缀
        if (this.threshold.configs && Array.isArray(this.threshold.configs)) {
          exportData.configs = this.threshold.configs.map(item => {
            const newItem = {};

            // 遍历所有属性，处理key的转换
            Object.keys(item).forEach(key => {
              let newKey = key;

              // 去掉key开头的"config"字符串
              if (key.startsWith("config")) {
                newKey = key.replace(/^config/, "");
                // 将首字母小写（如果剩余的字符首字母是大写的话）
                if (newKey.length > 0) {
                  newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
                }
              }

              // 处理值
              let value = item[key];
              // 如果是布尔值，转换为true/false
              if (key === "hasDelete" || key === "has_delete") {
                value = Boolean(value);
              }
              // 如果是数值字符串，转换为数字
              else if (
                typeof value === "string" &&
                !isNaN(value) &&
                value.trim() !== ""
              ) {
                const numValue = Number(value);
                if (!isNaN(numValue)) {
                  value = numValue;
                }
              }

              newItem[newKey] = value;
            });

            return newItem;
          });
        }

        // 转换为对象格式
        const objectFormat = {};
        if (this.threshold.configs && Array.isArray(this.threshold.configs)) {
          this.threshold.configs.forEach(item => {
            if (item.key || item.configKey) {
              const key = item.key || item.configKey;
              const value = item.value || item.configValue;

              // 尝试将value转换为数值类型
              const numValue = Number(value);
              objectFormat[key] = isNaN(numValue) ? value : numValue;
            }
          });
        }

        // 让用户选择导出格式
        this.$confirm("请选择导出格式", "导出选项", {
          confirmButtonText: "对象格式（键值对）",
          cancelButtonText: "数组格式（完整数据）",
          type: "info"
        })
          .then(() => {
            // 导出对象格式
            this.downloadJson(objectFormat, "object");
          })
          .catch(() => {
            // 导出数组格式
            this.downloadJson(exportData, "array");
          });
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败");
      }
    },

    downloadJson(data, format = "array") {
      const dataStr = JSON.stringify(data, null, 2);
      const dataBlob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement("a");

      link.href = url;
      const timestamp = new Date().getTime();
      const filename =
        format === "object"
          ? `${this.threshold.name || "threshold"}_object_${timestamp}.json`
          : `${this.threshold.name || "threshold"}_${timestamp}.json`;

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      this.$message.success(
        `导出成功（${format === "object" ? "对象格式" : "数组格式"}）`
      );
    }
  }
};
</script>

<style lang="less" scoped>
.threshold-detail-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.detail-container {
  background-color: #fafafa;
  border-radius: 4px;
}

.basic-info {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.info-item {
  margin-bottom: 10px;

  .label {
    color: #606266;
    font-weight: 500;
  }

  .value {
    color: #303133;
  }
}

.config-info {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.btns {
  padding: 20px;
  background-color: #fafafa;
  border-top: 1px solid #ebeef5;
  border-radius: 0 0 4px 4px;
}

.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00;
}

.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color: #00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/thresholdManagement/detail.vue